import React, { Component } from 'react'

export default class Error extends Component {
  render() {
    return (
      <div className="not-found">
        <h2>Oops!</h2>
        <br />
        <h2>We ran into an error processing your request. Please try again.</h2>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Error.js